import * as React from 'react';
import { SearchArticles } from 'containers/Search/EntitySearch/SearchArticles';
import { SearchProducts } from 'containers/Search/EntitySearch/SearchProducts';
import { SearchProfiles } from 'containers/Search/EntitySearch/SearchProfiles';
import { SearchPolls } from 'containers/Search/EntitySearch/SearchPolls';
import { SearchShops } from 'containers/Search/EntitySearch/SearchShops';
const { connect } = require('react-redux');
import { IStore } from 'redux/IStore';
import { IModalDescription } from 'models/modal';
import {
	MagazinePageManageType1,
	MagazinePageManageType2,
	MagazinePageManageType3,
	MagazinePageManageType4,
	MagazinePageManageType5,
	MagazinePageManageType6,
	MagazinePageManageType7,
	MagazinePageManageType8,
	MagazinePageManageType9,
	MagazinePageManageType10,
	MagazinePageSectionSelector,
	MagazinePageManageType11,
	MagazinePageManageType12,
	MagazinePageManageType13,
	MagazinePageManageType14,
	MagazinePageManageType15,
} from 'components/Magazine/Page/Sections';
import {
	PortalPageManageType2,
	PortalPageManageType3,
	PortalPageSectionSelector,
	PortalPageManageType4,
	PortalPageManageType5,
	PortalPageManageType6,
	PortalPageManageType7,
	PortalPageManageType8,
	PortalPageManageType9,
	PortalPageManageType10,
	PortalPageManageType11,
	PortalPageManageType12,
} from 'components/PortalPage/Sections';
import { ManageArticleTag } from 'containers/Administration/Articles/ArticleTags/ManageArticleTag';
import { ArticleGallery } from 'containers/Magazine/Article/ArticleGallery';
import { AdminArticleSettings } from 'containers/Administration/Articles/AdminArticleSettings';
import { ConfirmationDialog } from 'components/Common/Dialogs/ConfirmationDialog';
import { ManagePoll } from 'containers/Administration/Polls/ManagePoll';
import { LogInAsModal } from 'containers/AccessControl/Login/Modals/LogInAs';
import { LogInSuccessModal } from 'containers/AccessControl/Login/Modals/LogInSuccess';
import { CropImageModal } from 'containers/Image/CropImageModal';
import { DeactivateUser } from 'containers/User/DeactivateUser';
import { OnboardingQuiz } from 'containers/OnboardingQuiz';
import { CreateWardrobeItem } from 'containers/Wardrobe/CreateWardrobeItem';
import { EditWardrobeItem } from 'containers/Wardrobe/EditWardrobeItem';
import { RejectOrder } from 'components/Orders/RejectOrder';
import { ArticleFeaturedProductsSelectorModal } from 'containers/Administration/Articles/ManageArticle/FeaturedProductsSelectorModal';
import { ManageOutfit } from 'containers/Outfit/ManageOutfit';
import { MenuTypeSelector } from 'containers/Administration/MenuItem/MenuEditor/MenuTypeSelector';
import { MenuTypeCategory } from 'containers/Administration/MenuItem/MenuEditor/MenuTypes/MenuTypeCategory';
// import { MenuTypePage } from 'containers/Administration/MenuItem/MenuEditor/MenuTypes/MenuTypePage';
import { MenuTypeLink } from 'containers/Administration/MenuItem/MenuEditor/MenuTypes/MenuTypeLink';
import { SearchPopup } from 'containers/Search/SearchPopup';
import { AddCustomerModal } from 'containers/Shop/AddCustomerModal';
import { SelectStaffModalForm } from 'containers/BookAppointment/SelectStaffModal';
import { AddNewListingModal } from 'containers/Listings/AddNewListingModal';
import { OnboardingQuizEdit } from 'containers/OnboardingQuizEdit';
import { AddPaymentMethodModal } from 'containers/User/UserPaymentMethods/AddPaymentMethodModal';
import { SetFiltersModal } from 'containers/Home/SalonsPage/SetFiltersModal';
import { SetFiltersAppointmentModal } from 'containers/BookAppointment/StepSchedule/FilterFileds/SetFiltersAppointmentModal';
import { EditWeekWorkTime } from 'containers/Shop/OfficeWorkTime/EditWeekly';
import { EditDayWorkTime } from 'containers/Shop/OfficeWorkTime/EditDaily';
import { EditStaffMemberModal } from 'containers/Shop/Common/EditStaffMemberModal';
import { SaveShopServiceTemplate } from 'containers/Shop/ShopServices/ServicesListEdit/SaveShopServiceTemplate';
import { LoadShopServiceTemplate } from 'containers/Shop/ShopServices/ServicesListEdit/LoadShopServiceTemplate';
import { StaffMemberOverviewModal } from 'containers/Shop/Common/StaffMemberOverviewModal';
import { AddEditServiceGroup } from 'containers/Shop/ShopServices/ServicesListEdit/AddEditServiceGroup';
import { AddServicesToBundle } from 'containers/Shop/ShopBundlesServicesAddEdit/ShopBundlesAddEdit/AddServicesToBundle';
import { ManualBookingModal } from 'containers/Shop/ShopAppointments/ManualBookingModal';

const modalComponentLookupTable = {
	SearchArticles: SearchArticles,
	SearchProducts: SearchProducts,
	SearchProfiles: SearchProfiles,
	SearchPolls: SearchPolls,
	SearchShops: SearchShops,
	RejectOrder: RejectOrder,
	MagazinePageSectionSelector: MagazinePageSectionSelector,
	PortalPageSectionSelector: PortalPageSectionSelector,
	ManageArticleTag: ManageArticleTag,
	ArticleGallery: ArticleGallery,
	AdminArticleSettings: AdminArticleSettings,
	ConfirmationDialog: ConfirmationDialog,
	ManagePoll: ManagePoll,
	LogInAsModal: LogInAsModal,
	LogInSuccessModal: LogInSuccessModal,
	CropImageModal: CropImageModal,
	AddNewListingModal: AddNewListingModal,
	AddCustomerModal: AddCustomerModal,
	DeactivateUser: DeactivateUser,
	OnboardingQuiz: OnboardingQuiz,
	CreateWardrobeItem: CreateWardrobeItem,
	EditWardrobeItem: EditWardrobeItem,
	ArticleFeaturedProductsSelectorModal: ArticleFeaturedProductsSelectorModal,
	ManageOutfit: ManageOutfit,
	MenuTypeSelector: MenuTypeSelector,
	MenuTypeCategory: MenuTypeCategory,
	// 'MenuTypePage': MenuTypePage,
	MenuTypeLink: MenuTypeLink,
	SelectStaffModal: SelectStaffModalForm,
	OnboardingQuizEdit: OnboardingQuizEdit,
	SetFiltersModal: SetFiltersModal,
	SetFiltersAppointmentModal: SetFiltersAppointmentModal,
	EditStaffMemberModal: EditStaffMemberModal,
	StaffMemberOverviewModal: StaffMemberOverviewModal,
	AddEditServiceGroup: AddEditServiceGroup,
	AddServicesToBundle: AddServicesToBundle,

	/* magazine page Sections modals */
	ManageType1: MagazinePageManageType1,
	ManageType2: MagazinePageManageType2,
	ManageType3: MagazinePageManageType3,
	ManageType4: MagazinePageManageType4,
	ManageType5: MagazinePageManageType5,
	ManageType6: MagazinePageManageType6,
	ManageType7: MagazinePageManageType7,
	ManageType8: MagazinePageManageType8,
	ManageType9: MagazinePageManageType9,
	ManageType10: MagazinePageManageType10,
	ManageType11: MagazinePageManageType11,
	ManageType12: MagazinePageManageType12,
	ManageType13: MagazinePageManageType13,
	ManageType14: MagazinePageManageType14,
	ManageType15: MagazinePageManageType15,

	/* landing page Sections modals */
	PortalPageManageType2: PortalPageManageType2,
	PortalPageManageType3: PortalPageManageType3,
	PortalPageManageType4: PortalPageManageType4,
	PortalPageManageType5: PortalPageManageType5,
	PortalPageManageType6: PortalPageManageType6,
	PortalPageManageType7: PortalPageManageType7,
	PortalPageManageType8: PortalPageManageType8,
	PortalPageManageType9: PortalPageManageType9,
	PortalPageManageType10: PortalPageManageType10,
	PortalPageManageType11: PortalPageManageType11,
	PortalPageManageType12: PortalPageManageType12,

	SearchPopup: SearchPopup,

	EditWeekWorkTime: EditWeekWorkTime,
	EditDayWorkTime: EditDayWorkTime,
	SaveShopServiceTemplate: SaveShopServiceTemplate,
	LoadShopServiceTemplate: LoadShopServiceTemplate,
	AddPaymentMethodModal: AddPaymentMethodModal,
	ManualBookingModal,
};

interface IProps {
	modals?: any[];
}

@connect((state: IStore) => ({
	modals: state.modals,
}))
class ModalManager extends React.Component<IProps, {}> {
	constructor(props) {
		super(props);
	}

	public render() {
		const { modals } = this.props;

		const renderedModals = modals.map((modalDescription: IModalDescription, index: number) => {
			const { modalType, modalProps = {} } = modalDescription;
			const ModalComponent = modalComponentLookupTable[modalType];
			return <ModalComponent {...modalProps} key={modalType + index} />;
		});

		return <span>{renderedModals}</span>;
	}
}
export { ModalManager };
